module.exports = "<img src=\"{{srcUrl}}\" class=\"img-responsive\" />"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/picture-resource/picture-resource.component.html
// module id = I4J1
// module chunks = 1